import { TAccount } from '@helpers/Accounts/accounts.types';
import { TTopUpStatus } from '@helpers/GetTopUpStatus/getTopUpStatus.types';
import { DEOnly, UKOnly } from '@iwIntlProvider/CountryWrappers';

import { NotTopUpEligible } from '../notTopUpEligible/NotTopUpEligible';
import { NotYetTopUpEligible } from '../notYetTopUpEligible/NotYetTopUpEligible';
import { RepaymentsBeforeTopup } from '../repaymentsBeforeTopup/RepaymentsBeforeTopup';
import { TopUpDeclined } from '../topUpDeclined/TopUpDeclined';
import { TopUpPending } from '../topUpPending/TopUpPending';

export type TopUpTileProps = {
    accountId: NonNullable<TAccount['account_id']>;
    topUpStatus: TTopUpStatus;
    inFirstRepaymentTest: boolean;
    isOverdue: boolean;
    requestedCashAmount: number | undefined;
    requestedAmount: number | undefined;
    canTopUpAfterRepayments: boolean;
    isMicroloan: boolean;
    amountToRepayBeforeTopUp: number | undefined;
};

export const TopUpTile = (props: TopUpTileProps) => (
    <>
        <UKOnly>
            <TopUpTileUK {...props} />
        </UKOnly>
        <DEOnly>
            <TopUpTileDE {...props} />
        </DEOnly>
    </>
);

const TopUpTileUK = ({
    accountId,
    topUpStatus,
    inFirstRepaymentTest,
    isOverdue,
    requestedCashAmount,
    requestedAmount
}: TopUpTileProps) => {
    if (isOverdue) {
        return null;
    }

    switch (topUpStatus) {
        case 'NOT_YET_TOPUP_ELIGIBLE':
            if (!inFirstRepaymentTest) return <NotTopUpEligible />;
            return <NotYetTopUpEligible accountId={accountId} />;
        case 'TOPUP_PENDING':
            if (requestedCashAmount && requestedAmount) {
                return (
                    <TopUpPending
                        requestedCashAmount={requestedCashAmount}
                        requestedAmount={requestedAmount}
                    />
                );
            }

            return null;
        case 'TOPUP_DECLINED':
            return <TopUpDeclined />;
        case 'TOPUP_ELIGIBLE':
        case 'TOPUP_APPROVED':
        case 'PRE_APPROVED':
            return null;
        default:
            return <NotTopUpEligible />;
    }
};

const TopUpTileDE = ({
    canTopUpAfterRepayments,
    isMicroloan,
    amountToRepayBeforeTopUp
}: TopUpTileProps) => {
    if (!canTopUpAfterRepayments || isMicroloan) return null;

    return (
        <RepaymentsBeforeTopup
            amountToRepayBeforeTopUp={amountToRepayBeforeTopUp}
        />
    );
};
